import React from 'react';
import * as LucideIcons from 'lucide-react';
import { HelpCircle } from 'lucide-react';

function Icon({
    name,
    size = 24,
    color,
    className = "",
    strokeWidth = 2,
    ...props
}) {
    const IconComponent = LucideIcons[name];
    
    // Only use color prop if explicitly provided, otherwise let CSS handle it via currentColor
    const iconColor = color !== undefined ? color : "currentColor";

    if (!IconComponent) {
        return <HelpCircle size={size} color={iconColor} strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={iconColor}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}
export default Icon;